<template>
    <!--房贷计算器-->
    <div class="mortgage-calculator">
        <div class="main">
            <ul class="left">
                <li class="special">
                    <div class="item">
                        <span>户型</span>
                        <input type="text" placeholder="户型" v-model="propInfo.huxing">
                    </div>
                </li>
                <li>
                    <div class="item">
                        <span>面积</span>
                        <div class="rates">
                            <input type="text" placeholder="请输入面积" v-model="propInfo.area">
                            <span class="ac">m<sup>2</sup></span>
                        </div>

                    </div>
                    <div class="item">
                        <span>房屋总价</span>
                        <div class="rates">
                            <input type="text" placeholder="请输入总价" @change="allDk" v-model="propInfo.total_price">
                            <span class="ac">万</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="item">
                        <span>贷款类别</span>
                        <div class="select">
                            <select v-model="selectType">
                                <option :value="item.id" v-for="item in Types">{{ item.value }}</option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                    </div>
                    <div class="item" v-show="selectType === 0">
                        <span>商贷利率</span>
                        <div class="rates">
                            <input type="text" v-model="rates" onkeyup="value=value.replace(/[^\d||\.]/g,'')">
                            <span class="ac">%</span>
                        </div>
                    </div>
                    <div class="item" v-show="selectType === 1">
                        <span>公积金利率</span>
                        <div class="rates">
                            <input type="text" v-model="gongRates" onkeyup="value=value.replace(/[^\d||\.]/g,'')">
                            <span class="ac">%</span>
                        </div>
                    </div>
                </li>
                <li v-show="selectType === 2">
                    <div class="item">
                        <span>商贷利率</span>
                        <div class="rates">
                            <input type="text" v-model="rates" onkeyup="value=value.replace(/[^\d||\.]/g,'')">
                            <span class="ac">%</span>
                        </div>
                    </div>
                    <div class="item">
                        <span>公积金利率</span>
                        <div class="rates">
                            <input type="text" v-model="gongRates" onkeyup="value=value.replace(/[^\d||\.]/g,'')">
                            <span class="ac">%</span>
                        </div>
                    </div>
                </li>
                <li v-show="selectType === 2">
                    <div class="item">
                        <span>商贷总额</span>
                        <div class="rates" :class="getGong">
                            <input type="text" placeholder="请输入商业贷款总额" @change="allDk" v-model="shangTotal">
                            <span class="ac">万</span>
                            <a class="mess">{{ messageShang }}</a>
                        </div>
                    </div>
                    <div class="item">
                        <span>公积金总额</span>
                        <div class="rates" :class="getGong">
                            <input type="text" placeholder="请输入公积金贷款总额" @change="allDk" v-model="gongTotal">
                            <span class="ac">万</span>
                            <a class="mess">{{ messageGong }}</a>
                        </div>
                    </div>
                </li>
                <li class="special">
                    <div class="item">
                        <span>贷款年限</span>
                        <div class="select">
                            <select v-model="selectYears">
                                <option :value="item.id" v-for="item in Years">{{ item.value }}</option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                    </div>
                </li>
                <li v-show="selectType !== 2">
                    <div class="item">
                        <span>贷款成数</span>
                        <div class="select">
                            <select v-model="selectLTV">
                                <option :value="item.id" v-for="item in LTV">{{ item.value }}</option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                    </div>
                    <div class="item">
                        <span>贷款总额</span>
                        <input type="text" :value="total_loan" readonly>
                    </div>
                </li>
                <li class="special">
                    <div class="item">
                        <span>还款类型</span>
                        <div class="select">
                            <select v-model="selectPaymentType">
                                <option :value="item.id" v-for="item in paymentType">{{ item.value }}</option>
                            </select>
                            <i class="iconfont">&#xe619;</i>
                        </div>
                    </div>
                </li>
                <li class="special btn">
                    <button @click="toCount()" style="cursor: pointer">立即计算</button>
                </li>
            </ul>
            <div class="right">
                <span v-show="selectPaymentType === 0">等额本息还款</span>
                <span v-show="selectPaymentType === 1">等额本金还款</span>
                <div class="payment_box">
                    <ul class="left2">
                        <li>首付：</li>
                        <li>贷款总额：</li>
                        <li v-show="selectPaymentType === 1">每月应还本金：</li>
                        <li v-show="selectPaymentType === 1">第一月月供：</li>
                        <li v-show="selectPaymentType === 1">每月月供递减额：</li>
                        <li v-show="selectPaymentType === 0">每月还款：</li>
                        <li>总利息：</li>
                        <li>本息总额：</li>
                    </ul>
                    <ul class="right2">
                        <li>{{ down_payment }} 万元</li>
                        <li>{{ total_loan }} 万元</li>
                        <li v-show="selectPaymentType === 1">{{ principal }} 元</li>
                        <li v-show="selectPaymentType === 1">{{ first }} 元</li>
                        <li v-show="selectPaymentType === 1">{{ decrease }} 元</li>
                        <li v-show="selectPaymentType === 0">{{ yue_payment }} 元</li>
                        <li>{{ gross_interest }} 万元</li>
                        <li>{{ allTotal }} 万元</li>
                    </ul>
                </div>

                <p>以上结果仅供参考</p>
            </div>
        </div>
        <div class="close" v-show="propInfo.type === 1">
            <i class="iconfont" @click="closeCalculator()" style="cursor: pointer">&#xe617;</i>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	export default {
		props: {
			propInfo: {
				type: Object
			}
		},
		data() {
			return {
				isShow: true,
				// area: '',
				// price: '',
				// allprice: this.propInfo.total_price,
				rates: 4.9,//商贷利率
				gongRates: 3.25,//商贷利率
				rate: '',
				gongRate: '',
				gongTotal: '',//公积金贷款总额
				messageGong: '',
				messageShang: '',
				shangTotal: '',//商贷总额
				total_loan: 0,//贷款总额
				down_payment: 0,//首付
				yue_payment: 0,//月付
				gross_interest: 0,//总利息
				allTotal: 0,//本息总额
				selectPaymentType: 0,
				paymentType: [{value: '等额本息还款', id: 0}, {value: '等额本金还款', id: 1}],
				selectType: 0,
				Types: [{value: '商业贷款', id: 0}, {value: '公积金贷款', id: 1}, {value: '组合型贷款', id: 2}],
				selectYears: '10',
				Years: [{value: '5年', id: '5'}, {value: '10年', id: '10'}, {value: '15年', id: '15'}, {
					value: '20年', id: '20'
				}, {value: '25年', id: '25'}, {value: '30年', id: '30'}],
				// selectOptions:'',
				// options: [{value:'三室两厅 A'}, {value: '两室两厅'}, {value:'四室一厅'}],
				selectLTV: '7',//贷款成数
				LTV: [{value: '3成', id: '3'}, {value: '4成', id: '4'}, {value: '5成', id: '5'}, {
					value: '6成', id: '6'
				}, {value: '7成', id: '7'}],
				//等额本金
				principal: '',//每月应还本金
				first: '',//第一月月供
				decrease: '',//每月月供递减额
			}
		},
		computed: {
			getGong() {
				if (this.gongTotal !== '') {
					this.messageGong = ''
				}
				if (this.shangTotal !== '') {
					this.messageShang = ''
				}
			}
		},
		created() {
			// this.total_loan = Number(this.propInfo.total_price) * Number(this.selectLTV) / 10;
		},
		methods: {
			//关闭房贷计算器
			closeCalculator() {
				this.$emit('CalculaBack', false)
			},
			//立即计算
			toCount() {
				let selYear = parseInt(this.selectYears) * 12;
				if (this.selectType === 2) {
					if (this.gongTotal === '') {
						this.messageGong = '请输入公积金贷款总额'
					}
					if (this.shangTotal === '') {
						this.messageShang = '请输入商业贷款总额'
					}
					if (this.selectPaymentType === 0) {
						this.total_loan = Number(this.shangTotal) + Number(this.gongTotal);//贷款总额
						this.down_payment = (Number(this.propInfo.total_price) - this.total_loan).toFixed(2);//首付
						//商贷部分
						this.rate = (parseFloat(this.rates) / 100) / 12;
						let math2 = Math.pow((1 + this.rate), selYear);//(1+月利率)^还款月数 ^次方
						let yue_shang = (((parseFloat(this.shangTotal) * this.rate * math2) / (math2 - 1)) * 10000).toFixed(2)
						let allShang = Number(yue_shang * selYear / 10000).toFixed(2);
						let grossShang = Number(allShang - this.shangTotal).toFixed(2)
						//公积金部分
						this.gongRate = (parseFloat(this.gongRates) / 100) / 12;
						let math1 = Math.pow((1 + this.gongRate), selYear);//(1+月利率)^还款月数 ^次方
						let yue_gong = (((parseFloat(this.gongTotal) * this.gongRate * math1) / (math1 - 1)) * 10000).toFixed(2)
						let allgong = Number(yue_gong * selYear / 10000).toFixed(2);
						let grossGong = Number(allgong - this.gongTotal).toFixed(2)
						this.yue_payment = parseFloat(yue_gong) + parseFloat(yue_shang)//月付
						this.allTotal = (parseFloat(allgong) + parseFloat(allShang)).toFixed(2)//本息总额
						this.gross_interest = parseFloat(grossGong) + parseFloat(grossShang)//总利息
					}
					if (this.selectPaymentType === 1) {
						this.total_loan = Number(this.shangTotal) + Number(this.gongTotal);//贷款总额
						this.down_payment = (Number(this.propInfo.total_price) - this.total_loan).toFixed(2);//首付
						//商贷部分
						this.rate = (parseFloat(this.rates) / 100) / 12;
						// 每月应还本金
						let principal1 = (this.shangTotal / selYear * 10000).toFixed(2)
						// 第一月月供
						let first_shang = (parseFloat(principal1) + parseFloat(this.shangTotal * 10000 * this.rate)).toFixed(2)
						// 每月月供递减额
						let decrease1 = (principal1 * this.rate).toFixed(2)
						// 本息总额=〔(总贷款额÷还款月数+总贷款额×月利率)+总贷款额÷还款月数×(1+月利率)〕÷2×还款月数
						let total_shang = (((parseFloat(principal1) + parseFloat(this.shangTotal * 10000 * this.rate) + principal1 * (1 + this.rate)) / 2 * selYear) / 10000).toFixed(2)

						//公积金部分
						this.gongRate = (parseFloat(this.gongRates) / 100) / 12;
						// 每月应还本金
						let principal2 = (this.gongTotal / selYear * 10000).toFixed(2)
						// 第一月月供
						let first_gong = (parseFloat(principal2) + parseFloat(this.gongTotal * 10000 * this.gongRate)).toFixed(2)
						// 每月月供递减额
						let decrease2 = (principal2 * this.rate).toFixed(2)
						// 本息总额=〔(总贷款额÷还款月数+总贷款额×月利率)+总贷款额÷还款月数×(1+月利率)〕÷2×还款月数
						let total_gong = (((parseFloat(principal2) + parseFloat(this.gongTotal * 10000 * this.gongRate) + principal2 * (1 + this.gongRate)) / 2 * selYear) / 10000).toFixed(2)
						this.principal = parseFloat(principal1) + parseFloat(principal2) //每月应还本金
						this.first = (parseFloat(first_shang) + parseFloat(first_gong)).toFixed(2)//第一月月供
						this.decrease = (parseFloat(decrease1) + parseFloat(decrease2)).toFixed(2)
						this.allTotal = parseFloat(total_shang) + parseFloat(total_gong)//总利息
						this.gross_interest = (this.allTotal - this.total_loan).toFixed(2)
						// console.log(this.allTotal)
						// console.log(this.gross_interest)
					}
				} else {
					if (this.selectType === 1) {
						this.rate = (parseFloat(this.gongRates) / 100) / 12;
					}
					if (this.selectType === 0) {
						this.rate = (parseFloat(this.rates) / 100) / 12;
					}
					//等额本息还款
					if (this.selectPaymentType === 0) {
						let math = Math.pow((1 + this.rate), selYear);//(1+月利率)^还款月数 ^次方
						this.total_loan = Number(this.propInfo.total_price) * Number(this.selectLTV) / 10;//贷款总额
						this.down_payment = (Number(this.propInfo.total_price) - this.total_loan).toFixed(2);//首付
						this.yue_payment = (((parseFloat(this.total_loan) * this.rate * math) / (math - 1)) * 10000).toFixed(2)//月付
						this.allTotal = Number(this.yue_payment * selYear / 10000).toFixed(2);//本息总额
						this.gross_interest = Number(this.allTotal - this.total_loan).toFixed(2);//总利息
					}
					//等额本金还款
					if (this.selectPaymentType === 1) {
						this.total_loan = Number(this.propInfo.total_price) * Number(this.selectLTV) / 10;//贷款总额
						this.down_payment = (Number(this.propInfo.total_price) - this.total_loan).toFixed(2);//首付
						// 每月应还本金
						this.principal = (this.total_loan / selYear * 10000).toFixed(2)
						// 第一月月供
						this.first = (parseFloat(this.principal) + parseFloat(this.total_loan * 10000 * this.rate)).toFixed(2)
						// 每月月供递减额
						this.decrease = (this.principal * this.rate).toFixed(2)
						// 本息总额=〔(总贷款额÷还款月数+总贷款额×月利率)+总贷款额÷还款月数×(1+月利率)〕÷2×还款月数
						this.allTotal = (((parseFloat(this.principal) + parseFloat(this.total_loan * 10000 * this.rate) + this.principal * (1 + this.rate)) / 2 * selYear) / 10000).toFixed(2)
						//总利息
						this.gross_interest = (this.allTotal - this.total_loan).toFixed(2)
						// console.log(this.principal)
						// console.log(this.first)
						// console.log(this.decrease)
						// console.log(this.allTotal)
						// console.log(this.total_loan)
						// console.log(this.gross_interest)
					}
				}
			},
			allDk() {

			}
		},
		// watch:{
		// propInfo(newval,oldVal){
		// 	console.log(newval)
		//     }
		// },
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .mortgage-calculator {
        width: 1038px;
        position: relative;
        border: red;
        background: #fff;
        .main {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: #333;
            padding: 60px 80px;
            .left {
                width: 47.5%;
                li {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 30px;
                    text-align: right;
                    .reminder {
                        position: absolute;
                        top: 100%;
                        left: 70px;
                        color: #FF5E5E;
                    }
                    .item {
                        width: 47%;
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        span {
                            color: #666;
                            margin-right: 10px;
                        }
                        .select {
                            width: 110px;
                            position: relative;
                            color: #333;
                            select {
                                width: 100%;
                                height: 40px;
                                border: solid 1px #ccc;
                                appearance: none;
                                -moz-appearance: none;
                                -webkit-appearance: none;
                                padding: 0 24px 0 10px;
                                line-height: 32px;
                                border-radius: 4px;
                                outline: none;
                            }
                            i {
                                position: absolute;
                                top: 50%;
                                right: 10px;
                                transform: translateY(-50%);
                                font-size: 8px;
                            }
                            select::-ms-expand {
                                display: none;
                            }
                        }
                        .rates {
                            width: 110px;
                            display: flex;
                            align-items: center;
                            border: 1px solid #ccc;
                            border-radius: 4px;
                            input {
                                width: 90px;

                                border: none;
                            }
                            .mess {
                                position: absolute;
                                top: 100%;
                                right: 0;
                                color: #ff5e5e;
                            }
                        }
                        input {
                            width: 110px;
                            font-size: 14px;
                            color: #333;
                            border: 1px solid #ccc;
                            box-sizing: border-box;
                            outline: none;
                            padding: 11px 17px;
                            border-radius: 4px;
                        }
                    }
                    .items {
                        width: 100%;
                        .select {
                            width: 374px;
                        }
                    }
                    button {
                        width: 81%;
                        font-size: 14px;
                        color: #fff;
                        padding: 13px 0;
                        background: #FFA200;
                        border: none;
                        outline: none;
                    }
                }
                li.special {
                    width: 100%;
                    .item {
                        width: 100%;
                        .select {
                            width: 374px;
                        }
                        input {
                            width: 374px;
                        }
                    }
                }
                li.btn {
                    justify-content: flex-end;
                    margin-bottom: 0;
                }
            }
            .right {
                width: 47.5%;
                border: 1px solid #ccc;
                span {
                    display: block;
                    color: #666;
                    font-size: 18px;
                    padding: 40px 0;
                    text-align: center;
                }
                .payment_box {
                    display: flex;
                    justify-content: space-between;
                    margin: 0 100px;
                    .left2 {
                        display: flex;
                        width: 120px;
                        flex-direction: column;
                        color: #666;
                        text-align: right;
                        li {
                            margin-bottom: 30px;
                        }
                    }
                    .right2 {
                        li {
                            margin-bottom: 30px;
                        }
                    }
                }
                p {
                    font-size: 14px;
                    color: #ff5e5e;
                    text-align: center;
                }
            }
        }

        .close {
            position: absolute;
            top: -50px;
            right: 40px;
            i {
                font-size: 24px;
                color: #666;
            }
        }

    }
</style>